import videojs from 'video.js';
import Component from 'video.js/dist/types/component';
import Player from 'video.js/dist/types/player';

interface VideoJsOptions {
  controls: boolean;
  autoplay: boolean;
  preload: 'none' | 'metadata' | 'auto';
  loop: boolean;
  muted: boolean;
  playsinline: boolean;
  poster?: string;
  fluid: boolean;
  responsive: boolean;
  bigPlayButton: boolean;
  disablePictureInPicture: boolean;
}

export const initializePlayer = (videoElement: HTMLVideoElement, options: Partial<VideoJsOptions>): Player => {
  return videojs(videoElement, {
    ...options,
    userActions: {
      hotkeys: true
    },
    controlBar: {
      volumePanel: {
        inline: true
      }
    }
  });
};

export const setupPlayerEvents = (player: Player, onPlay: () => void, onUserActive: () => void) => {
  player.on('play', onPlay);
  player.on('useractive', onUserActive);
};

export const hideControlBar = (player: Player) => {
  const controlBar = player.getChild('ControlBar');
  if (controlBar) {
    controlBar.hide();
  }
  return controlBar;
};

export const showControlBar = (controlBar: Component | undefined) => {
  if (controlBar) {
    controlBar.show();
  }
};
